import { setMixpanelUser, trackMixpanelEvent } from "./mixpanel";
import { clearClientIpAddress } from "./GetIpAddress";

const utmData = () => {
  const params = Object.fromEntries(new URLSearchParams(window.location.search));
  if (["utm_source", "utm_campaign"].some((k) => Object.keys(params).includes(k))) {
    return params;
  }
};

const actions = {
  track: (name: string, props?: any, instantObj = { email: "", userId: "" }) => {
    const requestEmail = props.requestEmail;
     
    const utmDataSet = utmData();

    if (utmDataSet) {
      props = { ...props, ...utmDataSet };
    }

    if('error' != requestEmail) {
      trackMixpanelEvent(name, requestEmail, props).then();
    }
    
  },

  set: (user: any, email: string) => {

    const utmDataSet = utmData();
    if (utmDataSet) {
      user = { ...user, ...utmDataSet };
    }
    setMixpanelUser(email, user).then();
    
  },

  trackLogout: (name: string, props?: any, instantObj = { email: "", userId: "" }) => {
    actions.track(name, props);
    clearClientIpAddress();
  },
};

export const Mixpanel = actions;
